import React from 'react'
import { Section } from '../../components/Section'
import { SectionContentImageWithText } from '../../components/SectionContentImageWithText'

export const SectionContentInstanceMaraPerfectMatch: React.FunctionComponent =
  () => (
    <Section backgroundColor="white" padding={100}>
      <SectionContentImageWithText
        heading="The value of a perfect match"
        description={{
          description:
            'Staffing isn’t just about filling shifts; it’s about keeping operations running smoothly. A no-call, no-show can derail service, and the wrong hire can be worse than being short-staffed.\n\nWith Mara powering Qwick, businesses achieve some of the highest fill rates in the industry, surpassing traditional staffing agencies and job boards. Each shift is matched with experienced, reliable professionals who keep teams consistent and seamless.\n\nMara does the heavy lifting so you can skip resumes and interviews. Post a shift and get back to running your business while Mara takes care of the rest.',
        }}
        imagePlacement="right"
        image={{
          publicId: 'photography/mara-value-props',
          alt: 'Mara value propositions, less risk, more consistency, stronger teams.',
        }}
        showAppStoreLinks={false}
      />
    </Section>
  )
